var _defs, _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgIdCard = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "id-card_svg__Light",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".id-card_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "id-card_svg__cls-1",
  d: "M13.5 14.5h7M13.5 11.5h7M13.5 8.5H17"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "id-card_svg___Group_",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("circle", {
  className: "id-card_svg__cls-1",
  cx: 7,
  cy: 8.75,
  r: 2.25
}), /*#__PURE__*/React.createElement("path", {
  className: "id-card_svg__cls-1",
  d: "M11.5 15.5a4.644 4.644 0 00-9 0z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "id-card_svg__cls-1",
  d: "M1 3h22v16H1z"
})));

export default SvgIdCard;